module.exports = __webpack_public_path__ + "img/comfort.b38e24a8.jpg";